import React, { useEffect } from "react";
import { Layout, Row, Col, Button } from "antd";
import WorkOrderPaintC from "../../containers/work-order/work-order-paint/WorkOrderPaintC";
import { useHistory, useParams } from "react-router-dom";
import ContractorSteps from "./ContractorSteps";

const { Content } = Layout;

const ContractorWorkOrderPaint: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
  }, []);

  return (
    <Content>
      <div>
        <ContractorSteps current={1} />
      </div>

      <div className="steps-content">
        <Row gutter={24}>
          <Col className="gutter-row" span={24}>
            <WorkOrderPaintC />
          </Col>
        </Row>
      </div>
    </Content>
  );
};

export default ContractorWorkOrderPaint;
